import { ResourceExtendedProps } from './extended-props';

export interface DossierCustomMoveInfos {
  time: string;
  endTime: string;
  timezone: string;
  newResource?: ResourceExtendedProps;
  oldResource?: ResourceExtendedProps;
  resizeResource?: ResourceExtendedProps;
}
